import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from '@mui/material/Button';
import './NoIeSupport.scss';

export default function NoIeSupport() {
  const downloadChrome = 'https://www.google.com/chrome/';
  const downloadFirefox = 'https://www.mozilla.org/en-US/firefox/new/';

  return (
    <Row className="notice justify-content-center align-items-center content-section">
      <Col lg={5}>
        <div className="content-section content-title">
          Internet Explorer is not supported
        </div>
        <div>
          <p>
            It appears that you are using a browser (Internet Explorer) that we do not fully support. Please use a modern browser like Google Chrome, Mozilla Firefox, Edge
            or Safari
          </p>
        </div>
        <Row className="content-section button-content">
          <div className="button-card button-card-fn shadow-sm d-flex justify-content-center align-items-center button-content">
            <Button href={downloadChrome} startIcon={<img src='/logos/chrome.png' alt="Google Chrome Browser Logo"></img>}>
              Download Chrome
            </Button>
          </div>
          <div className="button-card button-card-fn shadow-sm d-flex justify-content-center align-items-center">
            <Button href={downloadFirefox} startIcon={<img src='/logos/firefox.png' alt="Mozilla Firefox Broswer Logo"></img>}>
              Download Firefox
            </Button>
          </div>
        </Row>
      </Col>
    </Row>
  );
}
